import { render, staticRenderFns } from "./ImportMentionsDialog.vue?vue&type=template&id=6059952b&scoped=true"
import script from "./ImportMentionsDialog.vue?vue&type=script&lang=js"
export * from "./ImportMentionsDialog.vue?vue&type=script&lang=js"
import style0 from "./ImportMentionsDialog.vue?vue&type=style&index=0&id=6059952b&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6059952b",
  null
  
)

export default component.exports